import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import React from 'react';

import { InputField } from 'Elements/Form';

export default function CustomerBasicInfo() {
  return (
    <Card elevation={1}>
      <CardHeader title="Asiakastiedot" />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <InputField
              fullWidth
              label="Asiakasnumero"
              name="customer.number"
              variant="outlined"
              placeholder="Syötä asiakasnumero"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
          <Grid item xs={6}>
            <InputField
              fullWidth
              label="Yritys"
              name="customer.company"
              variant="outlined"
              placeholder="Syötä yrityksen nimi"
              margin="normal"
              InputLabelProps={{ shrink: true }}
            ></InputField>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
